<template>
  <div class="card" v-show="currentCardId == 'job-category'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職種を入力</h2>
        <p>入力すると候補職種が表示されますので、選択してください</p>
      </div>
      <div class="card-content-list">
        <div class="item-name">あなたの職種</div>
        <div class="item-body">
          <div
            class="job-category-selector"
            style="width: 90%; position: relative"
          >
            <el-input
              v-model="jobSearchQuery"
              placeholder="あなたの職種を入力してください。"
              clearable
              class="input-lg"
              @input="onJobSearchInput"
              @focus="showJobDropdown = true"
              @blur="onJobSearchBlur"
            />
            <div
              v-show="showJobDropdown && filteredJobOptions.length > 0"
              class="job-dropdown-list"
            >
              <div
                v-for="item in filteredJobOptions"
                :key="item"
                class="job-dropdown-item"
                @mousedown.prevent="selectJobCategory(item)"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import jobCategoryOptions from '@/utils/format-edit/designRirekishoJobCategoryOptions.json'

defineProps<{
  currentCardId?: string
}>()

const formatData = useRirekishoFormatData()
const jobSearchQuery = ref('')
const showJobDropdown = ref(false)
const filteredJobOptions = ref<string[]>([])

function onJobSearchInput(query: string) {
  if (query !== '') {
    filteredJobOptions.value = jobCategoryOptions
      .filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) > -1)
      .slice(0, 20)
    showJobDropdown.value = true
  } else {
    filteredJobOptions.value = []
    formatData.job_category = ''
  }
}

function onJobSearchBlur() {
  setTimeout(() => {
    showJobDropdown.value = false
  }, 200)
}

function selectJobCategory(item: string) {
  formatData.job_category = item
  jobSearchQuery.value = item
  showJobDropdown.value = false
  filteredJobOptions.value = []
}

onBeforeMount(() => {
  if (formatData.job_category) {
    jobSearchQuery.value = String(formatData.job_category)
  }
})
</script>

<style lang="scss" scoped>
.job-category-selector {
  position: relative;
}

.job-dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  z-index: 1000;
}

.job-dropdown-item {
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;

  &:hover {
    background-color: #f5f7fa;
  }
}
</style>
